export function paddingZero(value) {
  return value >= 100 ? value : ((value >= 10 ? '0' : '00') + value)
}
